<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>{{$route.query.item ? "Item" : "Transaction"}} Settings</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<div class="switches" white-background>
	    		<!-- <v-switch label="Enable Stock Transfer" v-model="TransactionSettings.branchDivision" nomargin></v-switch> -->
		    	<!-- <v-switch label="Enable Beat/Area/Route" v-model="TransactionSettings.beatRouteArea" nomargin></v-switch> -->
		    	<!-- <v-switch label="Maintain stock as per MRP" v-model="TransactionSettings.mrpWiseStock" nomargin></v-switch> -->
				<!-- <v-switch label="Enable Number Series Type Wise" @change="fn_toggleNumberSeriesTypeWise" v-model="TransactionSettings.typeWiseNumberSeries" nomargin></v-switch> -->
		    	<!-- <v-switch label="Disable negative stock" v-model="TransactionSettings.disableNegativeStock" nomargin></v-switch> -->

				<v-list two-line nopadding v-if="$route.query.item">
					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Enable MRP</v-list-tile-title>
							<v-list-tile-sub-title>Enable MRP in items</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleMRP" v-model="TransactionSettings.mrpWiseStock" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<v-list-tile class="padding-right-8" v-if="TransactionSettings.mrpWiseStock">

						<v-list-tile-content>
							<v-list-tile-title>Use MRP as Sale Price</v-list-tile-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_post" v-model="TransactionSettings.mrpAsSalePrice" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<template v-if="$root.appVersion >= 194">
						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Enable Batch</v-list-tile-title>
								<v-list-tile-sub-title>Enable batch in stock</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_enableBatchAndFields" v-model="TransactionSettings.enableBatch" nomargin></v-switch>
							</v-list-tile-action>

							</v-list-tile>

							<v-card flat @click.native="fn_openDialogAddFields" v-if="TransactionSettings.enableBatch">
								<v-card-text>
									<div font16>Add/Remove Batch Fields <v-icon style="margin-bottom: -2px;">arrow_drop_down</v-icon></div>
									<div><span light-opacity-color v-for="(field, index) in TransactionSettings.batchFields" :key="index" v-if="field.id != 'opening'">{{ field.title }}<span v-if="TransactionSettings.batchFields.length - 1 != index">, </span></span></div>
								</v-card-text>
							</v-card>
					</template>

					<template v-if="$root.appVersion >= 234">
						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Enable Pack Qty</v-list-tile-title>
								<v-list-tile-sub-title>Show pack qty on the bill/invoices</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_post" v-model="TransactionSettings.showPacking" nomargin></v-switch>
							</v-list-tile-action>

							</v-list-tile>

							<v-list-tile class="padding-right-8" @click="fn_openDialogTextBox" v-if="TransactionSettings.showPacking">

							<v-list-tile-content>
								<v-list-tile-title>Pack Qty Label</v-list-tile-title>
								<v-list-tile-sub-title>{{ TransactionSettings.packingLabel ? TransactionSettings.packingLabel : 'Pack Qty' }}</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;padding-right:16px;">
								<v-icon font20>edit</v-icon>
							</v-list-tile-action>

						</v-list-tile>
					</template>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Low Stock Alert</v-list-tile-title>
							<v-list-tile-sub-title>Enable low stock alert</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleLowStockAlert" v-model="TransactionSettings.lowStockAlert" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>{{ $t('settings.transactionSettings.duplicateProductCode') }}</v-list-tile-title>
							<v-list-tile-sub-title>{{ $t('settings.transactionSettings.allowDuplicateProductCode') }}</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleDuplicateCode" v-model="TransactionSettings.allowDuplicateCode" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>
					
				</v-list>

				<v-list two-line nopadding v-else>
					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Number Series</v-list-tile-title>
							<v-list-tile-sub-title>Enable type wise for Sale Invoice</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleNumberSeriesTypeWise" v-model="TransactionSettings.typeWiseNumberSeries" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<template v-if="$root.appVersion >= 117">
						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Default Payment Mode</v-list-tile-title>
								<v-list-tile-sub-title>Payment mode for sale invoice</v-list-tile-sub-title>

							</v-list-tile-content>

							<v-menu style="border-radius: 5px;">
								<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
									<v-chip color="primary" class="pr-1 whitecolor" small>{{ selectedPaymentMode.title }} <v-icon class="whitecolor font20">arrow_drop_down</v-icon></v-chip>
								</v-list-tile-action>

								<v-list nopadding>
									<template v-for="(item, index) in paymentModes">
										<v-list-tile :key="index" @click="fn_selectDefaultPaymentMode(item)">
											<v-list-tile-content>
												<v-list-tile-title>{{item.title}}</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
									</template>
								</v-list>
							</v-menu>

						</v-list-tile>

						<template v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1">
							<v-divider></v-divider>

							<v-list-tile class="padding-right-8">
								<v-list-tile-content>
									<v-list-tile-title>E-Way Bill Details</v-list-tile-title>
									<v-list-tile-sub-title>Show eway bill details</v-list-tile-sub-title>
								</v-list-tile-content>

								<v-menu style="border-radius: 5px;">
									<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
										<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.eWayBillConfigValue === 1 ? "Always Enable" : "Standard" }} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
									</v-list-tile-action>

									<v-list nopadding>
										<template>
											<v-list-tile @click="fn_setEwayBillConfigValue(0)">
												<v-list-tile-content>
													<v-list-tile-title>Standard</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider></v-divider>
											<v-list-tile @click="fn_setEwayBillConfigValue(1)">
												<v-list-tile-content>
													<v-list-tile-title>Always Enable</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
										</template>
									</v-list>
								</v-menu>

							</v-list-tile>
						</template>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Show All Parties</v-list-tile-title>
								<v-list-tile-sub-title>Show customer and supplier in transactions</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleParties" v-model="TransactionSettings.showAllParties" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">
							<v-list-tile-content>
								<v-list-tile-title>Invoice Print Page Size</v-list-tile-title>
								<v-list-tile-sub-title>Change page size of invoice print</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-menu style="border-radius: 5px;">
								<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
									<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.printPageSize ? TransactionSettings.printPageSize : "A4"}} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
								</v-list-tile-action>

								<v-list nopadding>
									<template>
										<v-list-tile @click="fn_changePageSize('A4')">
											<v-list-tile-content>
												<v-list-tile-title>A4</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
										<v-divider></v-divider>
										<v-list-tile @click="fn_changePageSize('A5')">
											<v-list-tile-content>
												<v-list-tile-title>A5</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
										<v-divider></v-divider>
										<v-list-tile @click="fn_changePageSize('Letter')">
											<v-list-tile-content>
												<v-list-tile-title>Letter</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
									</template>
								</v-list>
							</v-menu>

						</v-list-tile>

						<template v-if="$root.appVersion >= 130">
							<v-divider></v-divider>

							<v-list-tile class="padding-right-8">
								<v-list-tile-content>
									<v-list-tile-title>Invoice Date</v-list-tile-title>
									<v-list-tile-sub-title>Set invoice date preference</v-list-tile-sub-title>
								</v-list-tile-content>

								<v-menu style="border-radius: 5px;">
									<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
										<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.transactionDateStatus == 2 ? "Last Remember" : "Current Date"}} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
									</v-list-tile-action>

									<v-list nopadding>
										<template>
											<v-list-tile @click="fn_transactionDate(1)">
												<v-list-tile-content>
													<v-list-tile-title>Current Date</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider></v-divider>
											<v-list-tile @click="fn_transactionDate(2)">
												<v-list-tile-content>
													<v-list-tile-title>Last Remember</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
										</template>
									</v-list>
								</v-menu>

							</v-list-tile>
						</template>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Ledger Statement</v-list-tile-title>
								<v-list-tile-sub-title>Remove Powered By BizOps App</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleLogoStatement" v-model="TransactionSettings.removeLogoFromStatement" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Ledger Statement</v-list-tile-title>
								<v-list-tile-sub-title>Enable Notes Field</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleNotesInStatement" v-model="TransactionSettings.ledgerStatementNotes" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Ledger Report/Statement</v-list-tile-title>
								<v-list-tile-sub-title>Credit/Debit Labels</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-menu style="border-radius: 5px;">
									<!-- ledgerCreditDebitLabelType -->
									 <!-- type == 1/null ToPay/ToReceive -->
									 <!-- type == 2 Debit/Credit -->
									<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
										<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.ledgerCreditDebitLabelType == 2 ? 'Credit/Debit' : "To Receive/To Pay"}} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
									</v-list-tile-action>

									<v-list nopadding>
										<template>
											<v-list-tile @click="fn_changeLedgerCreditDebitLabels(1)">
												<v-list-tile-content>
													<v-list-tile-title>To Receive / To Pay</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider></v-divider>
											<v-list-tile @click="fn_changeLedgerCreditDebitLabels(2)">
												<v-list-tile-content>
													<v-list-tile-title>Credit / Debit</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
										</template>
									</v-list>
								</v-menu>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">
							<v-list-tile-content>
								<v-list-tile-title>Estimate/Quotation Title</v-list-tile-title>
								<v-list-tile-sub-title>Set title for Estimate/Quotation print</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-menu style="border-radius: 5px;">
								<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
									<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.estimatePrintTitle ? TransactionSettings.estimatePrintTitle : "Estimate"}} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
								</v-list-tile-action>

								<v-list nopadding>
									<template>
										<v-list-tile @click="fn_changeEstimateTitle('Estimate')">
											<v-list-tile-content>
												<v-list-tile-title>Estimate</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
										<v-divider></v-divider>
										<v-list-tile @click="fn_changeEstimateTitle('Quotation')">
											<v-list-tile-content>
												<v-list-tile-title>Quotation</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
										<v-divider></v-divider>
										<v-list-tile @click="fn_changeEstimateTitle('Proforma Invoice')">
											<v-list-tile-content>
												<v-list-tile-title>Proforma Invoice</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
									</template>
								</v-list>
							</v-menu>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">
							<v-list-tile-content>
								<v-list-tile-title>Sale Return Title</v-list-tile-title>
								<v-list-tile-sub-title>Set title for Sale Return print</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-menu style="border-radius: 5px;">
								<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
									<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.saleReturnPrintTitle ? TransactionSettings.saleReturnPrintTitle : "Sale Return"}} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
								</v-list-tile-action>

								<v-list nopadding>
									<template>
										<v-list-tile @click="fn_changeSaleReturnTitle('Sale Return')">
											<v-list-tile-content>
												<v-list-tile-title>Sale Return</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
										<v-divider></v-divider>
										<v-list-tile @click="fn_changeSaleReturnTitle('Credit Note')">
											<v-list-tile-content>
												<v-list-tile-title>Credit Note</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
									</template>
								</v-list>
							</v-menu>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">
							<v-list-tile-content>
								<v-list-tile-title>Purchase Return Title</v-list-tile-title>
								<v-list-tile-sub-title>Set title for Purchase Return print</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-menu style="border-radius: 5px;">
								<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
									<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.purchaseReturnPrintTitle ? TransactionSettings.purchaseReturnPrintTitle : "Purchase Return"}} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
								</v-list-tile-action>

								<v-list nopadding>
									<template>
										<v-list-tile @click="fn_changePurchaseReturnTitle('Purchase Return')">
											<v-list-tile-content>
												<v-list-tile-title>Purchase Return</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
										<v-divider></v-divider>
										<v-list-tile @click="fn_changePurchaseReturnTitle('Debit Note')">
											<v-list-tile-content>
												<v-list-tile-title>Debit Note</v-list-tile-title>
											</v-list-tile-content>
										</v-list-tile>
									</template>
								</v-list>
							</v-menu>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Set Round Off</v-list-tile-title>
								<v-list-tile-sub-title>Set default in transaction forms</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleAutoRoundOff" v-model="TransactionSettings.isAutoRoundOff" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8" v-if="$root.appVersion >= 213">

							<v-list-tile-content>
								<v-list-tile-title>Enable Walk-in Customer</v-list-tile-title>
								<v-list-tile-sub-title>Set Walk-in customer as default</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleCashSaleDefault" v-model="TransactionSettings.cashSaleDefault" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8" v-if="$root.appVersion >= 213">

							<v-list-tile-content>
								<v-list-tile-title>Hide Bank Details (Invoice)</v-list-tile-title>
								<v-list-tile-sub-title>Hide if Walk-in customer</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleBankDetails" v-model="TransactionSettings.hideBankDetails" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<template v-if="$root.CurrentBusiness.GSTRegistrationStatus != 1">
							<v-divider></v-divider>

							<v-list-tile class="padding-right-8">
								<v-list-tile-content>
									<v-list-tile-title>Invoice Title</v-list-tile-title>
									<v-list-tile-sub-title>Set title for sale invoice</v-list-tile-sub-title>
								</v-list-tile-content>

								<v-menu style="border-radius: 5px;">
									<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
										<v-chip class="pr-1" color="primary" small whitecolor>{{ TransactionSettings.invoicePrintTitle ? TransactionSettings.invoicePrintTitle : "Default"}} <v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
									</v-list-tile-action>

									<v-list nopadding>
										<template>
											<v-list-tile @click="fn_changeInvoiceTitle('Default')">
												<v-list-tile-content>
													<v-list-tile-title>Default</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider></v-divider>
											<v-list-tile @click="fn_changeInvoiceTitle('Invoice')">
												<v-list-tile-content>
													<v-list-tile-title>Invoice</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider></v-divider>
											<v-list-tile @click="fn_changeInvoiceTitle('Bill')">
												<v-list-tile-content>
													<v-list-tile-title>Bill</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-divider></v-divider>
											<v-list-tile @click="fn_changeInvoiceTitle('Bill/Credit')">
												<v-list-tile-content>
													<v-list-tile-title>Bill/Credit</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
										</template>
									</v-list>
								</v-menu>

							</v-list-tile>
						</template>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Show Party Balance</v-list-tile-title>
								<v-list-tile-sub-title>Show party's current and previous balance in invoice</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_togglePartyBalance" v-model="TransactionSettings.showPartyBalance" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<template v-if="$root.appVersion >= 213">
							<v-list-tile class="padding-right-8">

								<v-list-tile-content>
									<v-list-tile-title>Enable Prescribe By Details</v-list-tile-title>
									<v-list-tile-sub-title>Add name, mobile number and address</v-list-tile-sub-title>
								</v-list-tile-content>

								<v-list-tile-action>
									<v-switch style="padding: 0 !important;" @change="fn_togglePrescribeDetails" v-model="TransactionSettings.enablePrescribeDetails" nomargin></v-switch>
								</v-list-tile-action>

							</v-list-tile>

							<v-list-tile class="padding-right-8">

								<v-list-tile-content>
									<v-list-tile-title>Enable Referred By Details</v-list-tile-title>
									<v-list-tile-sub-title>Add name, mobile number and address</v-list-tile-sub-title>
								</v-list-tile-content>

								<v-list-tile-action>
									<v-switch style="padding: 0 !important;" @change="fn_toggleReferredDetails" v-model="TransactionSettings.enableReferrerDetails" nomargin></v-switch>
								</v-list-tile-action>

							</v-list-tile>

							<v-list-tile class="padding-right-8">

								<v-list-tile-content>
									<v-list-tile-title>Barcode Scan</v-list-tile-title>
									<v-list-tile-sub-title>Enable item barcode scanner</v-list-tile-sub-title>
								</v-list-tile-content>

								<v-list-tile-action>
									<v-switch style="padding: 0 !important;" @change="fn_toggleBarcodeScan" v-model="TransactionSettings.enableBarcodeScan" nomargin></v-switch>
								</v-list-tile-action>

								</v-list-tile>
						</template>

						
					</template>

					<template v-if="$root.appVersion >= 314">
						<v-divider></v-divider>

						<v-list-tile class="padding-right-8" @click="fn_accountGroupSetting">

							<v-list-tile-content>
								<v-list-tile-title>Ledger/Party Fields</v-list-tile-title>
								<v-list-tile-sub-title>Add/Update fields in party ledgers</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-icon>keyboard_arrow_right</v-icon>
							</v-list-tile-action>

						</v-list-tile>
					</template>

					<template v-if="$root.appVersion >= 234">

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8" to="/settings/transaction">

							<v-list-tile-content>
								<v-list-tile-title>Transaction Fields</v-list-tile-title>
								<v-list-tile-sub-title>Add/Update transaction fields</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-icon>keyboard_arrow_right</v-icon>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Show Party Mobile Number</v-list-tile-title>
								<v-list-tile-sub-title>Show in sale/purchase lists</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_togglePartyMobile" v-model="TransactionSettings.showPartyMobile" nomargin></v-switch>
							</v-list-tile-action>

							</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Landscape Invoice</v-list-tile-title>
								<v-list-tile-sub-title>Change invoice Orientation to landscape</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleInvoiceOrientation" v-model="TransactionSettings.invoiceOrientation" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Secondary Unit in reports</v-list-tile-title>
								<v-list-tile-sub-title>Show in primary and secondary units in report</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleSecondaryUnit" v-model="TransactionSettings.showSecondaryUnit" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>
					</template>

					<template v-if="$root.appVersion >= 281">
						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Enable Salesman</v-list-tile-title>
								<v-list-tile-sub-title>Tag salesman on billing</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleSalesman" v-model="TransactionSettings.enableSalesman" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Enable broker</v-list-tile-title>
								<v-list-tile-sub-title>Tag broker on billing</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleBroker" v-model="TransactionSettings.enableBroker" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>
					</template>

					<v-divider></v-divider>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Customer Signature</v-list-tile-title>
							<v-list-tile-sub-title>Show customer's signature field on receipt/payment</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleCustomerSignature" v-model="TransactionSettings.enableCustomerSignature" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<v-divider></v-divider>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Invoice (GST/Discount in single line)</v-list-tile-title>
							<v-list-tile-sub-title>Show GST/Discount in single line</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleSingleLineAddOns" v-model="TransactionSettings.enableSingleLineAddOns" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<v-divider></v-divider>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Hide Day from Mfg/Exp (Batch)</v-list-tile-title>
							<v-list-tile-sub-title>Remove day from Mfg and Exp dates in batch</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleMfgExpDay" v-model="TransactionSettings.hideMfgExpDay" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<template v-if="$root.appVersion >= 297">
						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">
							<v-list-tile-content>
								<v-list-tile-title>Enable Godown Management</v-list-tile-title>
								<v-list-tile-sub-title>Manage inventory godown wise</v-list-tile-sub-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleGodown" v-model="TransactionSettings.enableGodown" nomargin></v-switch>
							</v-list-tile-action>
						</v-list-tile>

						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">
							<v-list-tile-content>
								<v-list-tile-title>Enable Bill of Materials</v-list-tile-title>
								<v-list-tile-sub-title>Enable bill of materials</v-list-tile-sub-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_toggleBillofMaterials" v-model="TransactionSettings.enableBillMaterials" nomargin></v-switch>
							</v-list-tile-action>
						</v-list-tile>

						<template v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1">
							<v-divider></v-divider>

							<v-list-tile class="padding-right-8">
								<v-list-tile-content>
									<v-list-tile-title>E-Way Bill</v-list-tile-title>
									<v-list-tile-sub-title>Enable E-Way Bill JSON option</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-switch style="padding: 0 !important;" @change="fn_toggleEwayBill" v-model="TransactionSettings.enableEwayBill" nomargin></v-switch>
								</v-list-tile-action>
							</v-list-tile>

							<v-divider></v-divider>

							<v-list-tile class="padding-right-8">
								<v-list-tile-content>
									<v-list-tile-title>E-Invoice</v-list-tile-title>
									<v-list-tile-sub-title>Enable e-invoice option</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-switch style="padding: 0 !important;" @change="fn_toggleEinvoice" v-model="TransactionSettings.enableEinvoice" nomargin></v-switch>
								</v-list-tile-action>
							</v-list-tile>
						</template>
					</template>

					<v-divider></v-divider>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Invoice Print (Full Page)</v-list-tile-title>
							<v-list-tile-sub-title>Enable full page invoice print out</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleFullPagePrint" v-model="TransactionSettings.fullPagePrint" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>

					<template v-if="$root.appVersion >= 305">
						<v-divider></v-divider>

						<v-list-tile class="padding-right-8">

							<v-list-tile-content>
								<v-list-tile-title>Party Wise Rate</v-list-tile-title>
								<v-list-tile-sub-title>Enable rate party wise in sale forms</v-list-tile-sub-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-switch style="padding: 0 !important;" @change="fn_togglePartyWiseRate" v-model="TransactionSettings.partyWiseRate" nomargin></v-switch>
							</v-list-tile-action>

						</v-list-tile>
					</template>
					
					<v-divider></v-divider>

					<v-list-tile class="padding-right-8">
						<v-list-tile-content>
							<v-list-tile-title>Invoice Date Format</v-list-tile-title>
							<v-list-tile-sub-title>Change date format for invoice print</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-menu style="border-radius: 5px;">
							<v-list-tile-action slot="activator" style="min-width: auto;flex-direction:row;justify-content:end;">
								<v-chip class="pr-1" color="primary" small whitecolor>
									<template v-if="TransactionSettings.invoiceDateFormat">
										{{currentDate | moment(TransactionSettings.invoiceDateFormat)}}
									</template>
									<template v-else>
										{{ currentDate | moment('DD-MMM-YYYY')}}
									</template>
									<v-icon class="font20 whitecolor">arrow_drop_down</v-icon></v-chip>
							</v-list-tile-action>
							<v-list two-line dense nopadding>
								<template>
									<v-list-tile @click="fn_changeInvoiceDateFormat('DD-MMM-YYYY')">
										<v-list-tile-content>
											<v-list-tile-title>DD-MMM-YYYY</v-list-tile-title>
											<v-list-tile-sub-title>{{new Date() | moment('DD-MMM-YYYY')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-divider></v-divider>
									<v-list-tile @click="fn_changeInvoiceDateFormat('DD-MMM-YYYY hh:mm A')">
										<v-list-tile-content>
											<v-list-tile-title>DD-MMM-YYYY HH:MM AM/PM</v-list-tile-title>
											<v-list-tile-sub-title>{{new Date() | moment('DD-MMM-YYYY hh:mm A')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-divider></v-divider>
									<v-list-tile @click="fn_changeInvoiceDateFormat('DD/MM/YYYY')">
										<v-list-tile-content>
											<v-list-tile-title>DD/MM/YYYY</v-list-tile-title>
											<v-list-tile-sub-title>{{currentDate | moment('DD/MM/YYYY')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-divider></v-divider>
									<v-list-tile @click="fn_changeInvoiceDateFormat('DD/MM/YYYY hh:mm A')">
										<v-list-tile-content>
											<v-list-tile-title>DD/MM/YYYY HH:MM AM/PM</v-list-tile-title>
											<v-list-tile-sub-title>{{currentDate | moment('DD/MM/YYYY hh:mm A')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-divider></v-divider>
									<v-list-tile @click="fn_changeInvoiceDateFormat('MM/DD/YYYY')">
										<v-list-tile-content>
											<v-list-tile-title>MM/DD/YYYY</v-list-tile-title>
											<v-list-tile-sub-title>{{new Date() | moment('MM/DD/YYYY')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-divider></v-divider>
									<v-list-tile @click="fn_changeInvoiceDateFormat('MM/DD/YYYY hh:mm A')">
										<v-list-tile-content>
											<v-list-tile-title>MM/DD/YYYY HH:MM AM/PM</v-list-tile-title>
											<v-list-tile-sub-title>{{new Date() | moment('MM/DD/YYYY hh:mm A')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-divider></v-divider>
									<v-list-tile @click="fn_changeInvoiceDateFormat('YYYY-MM-DD')">
										<v-list-tile-content>
											<v-list-tile-title>YYYY-MM-DD</v-list-tile-title>
											<v-list-tile-sub-title>{{new Date() | moment('YYYY-MM-DD')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-divider></v-divider>
									<v-list-tile @click="fn_changeInvoiceDateFormat('YYYY-MM-DD hh:mm A')">
										<v-list-tile-content>
											<v-list-tile-title>YYYY-MM-DD HH:MM AM/PM</v-list-tile-title>
											<v-list-tile-sub-title>{{new Date() | moment('YYYY-MM-DD hh:mm A')}}</v-list-tile-sub-title>
										</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</v-menu>

					</v-list-tile>

					<v-divider></v-divider>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Invoice/Bill Due Date</v-list-tile-title>
							<v-list-tile-sub-title>Show due date on invoice/bill Print</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleDueDate" v-model="TransactionSettings.showDueDate" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile>
					
					

					<!-- <v-divider></v-divider>

					<v-list-tile class="padding-right-8">

						<v-list-tile-content>
							<v-list-tile-title>Disable Received Amount (Invoice)</v-list-tile-title>
							<v-list-tile-sub-title>Hide/Show received amount from invoice</v-list-tile-sub-title>
						</v-list-tile-content>

						<v-list-tile-action>
							<v-switch style="padding: 0 !important;" @change="fn_toggleReceivedAmount" v-model="TransactionSettings.disableReceiveAmountLabel" nomargin></v-switch>
						</v-list-tile-action>

					</v-list-tile> -->

				</v-list>
	    	</div>

	    </div>

	    <dialog-confirmation ref="ref_dialogConfirmation" header="Quit Settings?" :actionMethod="fn_discard"></dialog-confirmation>

		<v-dialog v-model="dialogBatchFields" scrollable fullscreen persistent max-width="320px" transition="dialog-transition">

			<v-card flat full-height>
				<v-card-title noshadow primary-title class="pl-3 pt-2 pr-0 pb-2 title">
					{{ reorder ? 'Reorder Fields' : 'Add/Remove Fields' }}
					<v-spacer></v-spacer>
					<v-btn color="primary" flat small nopadding @click="reorder = !reorder">{{ !reorder ? 'Re-Order' : 'Done' }}</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text full-height class="pr-0 pl-0" :class="{'pt-0':reorder}">

					<v-alert type="info" icon="info_outline" class="mb-3" :value="true" v-if="reorder">
						Select field to change order
					</v-alert>

					<v-list nopadding>
						<v-list-tile class="padding-right-8" @click="fn_selectToReorder(item)" v-for="(item, index) in batchFields" :key="index" v-if="item.id != 'opening'">
							<v-list-tile-content>
								<v-list-tile-title>{{ item.title }}</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-switch v-if="!reorder" v-model="item.status" :disabled="item.isDefault" nomargin></v-switch>
								<v-icon v-else>{{ item.selected ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>
					
				</v-card-text>
				<v-card-actions>

					<v-layout row wrap v-if="reorder" style="border-top: 1px #ddd solid;">
                        <v-flex xs6 sm6 md6 pt-2 pb-2>
                            <v-btn block flat style="border-right: 1px #ddd solid;" :disabled="fn_isMoveDownDisabled()" color="primary" @click="fn_moveField('down')">Move Down <v-icon right color="primary">arrow_downward</v-icon></v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 pt-2 pb-2>
                            <v-btn block flat color="primary" :disabled="fn_isMoveUpDisabled()" @click="fn_moveField('up')">Move Up <v-icon right color="primary">arrow_upward</v-icon></v-btn>
                        </v-flex>
                    </v-layout>

					<v-layout row wrap v-else style="border-top: 1px #ddd solid;">
                        <v-flex xs6 sm6 md6 pt-2 pb-2>
                            <v-btn block flat style="border-right: 1px #ddd solid;" color="primary" @click="dialogBatchFields=false">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6pt-2 pb-2>
                            <v-btn block flat style="height: 48px;" color="primary" @click="fn_enableBatchAndFields">Done</v-btn>
                        </v-flex>
                    </v-layout>
				</v-card-actions>
			</v-card>
			
		</v-dialog>

		<dialog-text ref="ref_dialogText" title="Pack Qty Label" :textContent="dialogTextContent"></dialog-text>

	</div>
</template>

<script>
const dialogjs =  require('../../masters/forms/dialog').dialogjs;
const accountGroupIds = require('../../../config.js').configs.accountGroupIds;
import dialogConfirmation from '../../dialogs/dialog_confirmation'
import dialogText from './dialogs/dialog_text'

	export default{
		data(){
			return{
				TransactionSettings:{"businessId":null, "branchDivision":false, "beatRouteArea":false, "mrpWiseStock":false, "disableNegativeStock":false, "gstType":1, "typeWiseNumberSeries":false, "defaultPaymentMode":1, "eWayBillConfigValue":0, "showAllParties":false, "printPageSize":null, "transactionDateStatus":null, "estimatePrintTitle":null, "saleReturnPrintTitle":null, "purchaseReturnPrintTitle":null, "invoicePrintTitle":null, "enableBatch":false, "batchFields":null, "showPartyBalance":false, "enablePrescribeDetails":false, "enableReferrerDetails":false, "enableBarcodeScan":false, "ledgerCreditDebitLabelType":null, "cashSaleDefault":false, "showPacking":false, "packingLabel":null, "showPartyMobile":false, "invoiceOrientation":false, "showSecondaryUnit":false, "enableSalesman":false, "enableBroker":false, "enableCustomerSignature":false, "enableSingleLineAddOns":false, "hideBankDetails":false, "hideMfgExpDay":false, "mrpAsSalePrice":false, "enableGodown":false, "enableEwayBill":false, "enableEinvoice":false, "lowStockAlert":false, "enableBillMaterials":false, "fullPagePrint":false, "partyWiseRate":false, "invoiceDateFormat":null, "allowDuplicateCode":false, "showDueDate":false},
				formId:null,
				askToQuit:false,
				paymentModes:[{"title":"Last Remember", "value":1}, {"title":"Cash", "value":2}, {"title":"Credit", "value":3}],
				selectedPaymentMode:{"title":"Last Remember", "value":1},
				dialogBatchFields:false,
				batchFields:[
					{"id":"batchNumber", "title":"Batch Number", "status":true, "type":"string", "orderNumber":1},
					{"id":"opening", "title":"Opening", "status":true, "type":"number", "orderNumber":2},
					{"id":"mfgDate", "title":"Mfg Date", "status":true, "type":"date", "orderNumber":3},
					{"id":"expDate", "title":"Exp Date", "status":true, "type":"date", "orderNumber":4},
					{"id":"batchSize", "title":"Size", "status":false, "type":"string", "orderNumber":5},
					{"id":"batchMRP", "title":"MRP", "status":false, "type":"number", "orderNumber":6},
					{"id":"purchaseRate", "title":"Purchase Rate", "status":false, "type":"number", "orderNumber":7},
					{"id":"field1", "title":"Serial Number", "status":false, "type":"string", "orderNumber":8}, //(serialNumber)
					{"id":"field2", "title":"IMEI Number", "status":false, "type":"string", "orderNumber":9}, //(imeiNumber)
					{"id":"field3", "title":"Part Number", "status":false, "type":"string", "orderNumber":10}, //(partNumber)
					{"id":"field4", "title":"Model Number", "status":false, "type":"string", "orderNumber":11} //(modelNumber)
				],
				// batchFields:{
				// 	batchNumber:{"id":"batchNumber", "title":"Batch Number", "status":true, "isDefault":true, "type":"string", "orderNumber":1},
				// 	opening:{"id":"opening", "title":"Opening", "status":true, "type":"number", "orderNumber":2},
				// 	mfgDate:{"id":"mfgDate", "title":"Mfg Date", "status":true, "type":"date", "orderNumber":3},
				// 	expDate:{"id":"expDate", "title":"Exp Date", "status":true, "type":"date", "orderNumber":4},
				// 	batchSize:{"id":"batchSize", "title":"Size", "status":false, "type":"string", "orderNumber":5},
				// 	batchMRP:{"id":"batchMRP", "title":"MRP", "status":false, "type":"number", "orderNumber":6},
				// 	purchaseRate:{"id":"purchaseRate", "title":"Purchase Rate", "status":false, "type":"number", "orderNumber":7},
				// 	field1:{"id":"field1", "title":"Serial Number", "status":false, "type":"string", "orderNumber":8}, //(serialNumber)
				// 	field2:{"id":"field2", "title":"IMEI Number", "status":false, "type":"string", "orderNumber":9}, //(imeiNumber)
				// 	field3:{"id":"field3", "title":"Part Number", "status":false, "type":"string", "orderNumber":10}, //(partNumber)
				// 	field4:{"id":"field4", "title":"Model Number", "status":false, "type":"string", "orderNumber":11} //(modelNumber)
				// },
				reorder:false,

				// textDialogType:null,
				// textDialogTitle:null,
				dialogTextContent:null,
				currenDateTimer:null,
				currentDate: new Date()
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation,
			'dialog-text':dialogText
		},
		methods:{
			fn_goBack: function(){
				// this.askToQuit = true;
				this.$router.go(-1);
			},

			fn_openDialogConfirmation: function(){
				this.fn_openDialogWeb('web', 'DiscardDialog', 'ref_dialogConfirmation');
			},

			fn_discard: function(){
				this.fn_closeDialog();
				this.askToQuit = false;
				let self = this;
				setTimeout(function(){
					self.$router.go(-1);
				},300);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var dialogObj = {};
				dialogObj.tagId = this.guidWeb();
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function(){
				this.askToQuit = false;
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkTaxMode: function(){
				let self = this;
				let filterObject = {};
				filterObject.transactionTypeId = [10001, 10002, 10003, 10004, 100005];
				filterObject.taxMode = this.TransactionSettings.gstType;
				this.getFilterData('CheckTaxMode', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let isSimilar = JSON.parse(response);
							!isSimilar ? self.TransactionSettings.gstType = -1 : '';
				        }, 
				        onError: function(error){
				          	console.log(error);
				        }
					}
		        );
			},

			fn_selectDefaultPaymentMode: function(item){
				this.selectedPaymentMode = item;
				this.TransactionSettings.defaultPaymentMode = item.value;
				this.fn_post();
			},

			fn_setEwayBillConfigValue: function(val){
				this.TransactionSettings.eWayBillConfigValue = val;
				this.fn_post();
			},

            fn_toggleNumberSeriesTypeWise: function(val){
                let self = this;
                let typeArr = null;
				let title = "Tax Invoice";
				let taxMode = 1;
				if(this.$root.CurrentBusiness.GSTRegistrationStatus == 2){
					title = "Bill of Supply";
					taxMode = 0;
				}
				else if(this.$root.CurrentBusiness.GSTRegistrationStatus == 3){
					title = "Invoice";
					taxMode = 0;
				}
                if(val){
                    typeArr = [
                        // Retail Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Retail Invoice","numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":0,"transactionNature":null,"transactionTypeFormId":"33e66294-8148-1b9e-0090-50aa87b20cb5","transactionTypeId":10003,"isSystem":1,"isDefault":true},
                        // Wholesale Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Wholesale Invoice","numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"757c506e-9a73-e012-2632-4c29b0c0ac18","transactionTypeId":10003,"isSystem":1,"isDefault":false},
                        // Export Invoice
                        {"accountData":null,"additionalData":null,"central":false,"centralTransactionAccountId":null,"fieldsData":null,"importExport":true,"importExportTransactionAccountId":"daf504a8-8355-4985-b414-505471c895b1","inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":false,"localTransactionAccountId":null,"name":"Export Invoice","numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"5ed488ce-ed95-6d93-96d0-3cc463951983","transactionTypeId":10003,"isSystem":1,"isDefault":false}
                    ]
                }
                else{
                    typeArr = [
                        // Retail Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Retail Invoice","numberSeriesId":"1af6f388-e3c1-2cba-11df-7138cd7a5c1e","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":0,"transactionNature":null,"transactionTypeFormId":"33e66294-8148-1b9e-0090-50aa87b20cb5","transactionTypeId":10003,"isSystem":1,"isDefault":true},
                        // Wholesale Invoice
                        {"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":"41f99d4b-e806-422b-8036-8ecb8ba3e24d","fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":"90470ef2-7d52-4707-80d4-24c4cb28d768","name":"Wholesale Invoice","numberSeriesId":"1af6f388-e3c1-2cba-11df-7138cd7a5c1e","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"757c506e-9a73-e012-2632-4c29b0c0ac18","transactionTypeId":10003,"isSystem":1,"isDefault":false},
                        // Export Invoice
                        {"accountData":null,"additionalData":null,"central":false,"centralTransactionAccountId":null,"fieldsData":null,"importExport":true,"importExportTransactionAccountId":"daf504a8-8355-4985-b414-505471c895b1","inventory":null,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":false,"localTransactionAccountId":null,"name":"Export Invoice","numberSeriesId":"1af6f388-e3c1-2cba-11df-7138cd7a5c1e","paymentMode":1,"salesGroupType":1,"taxMode":taxMode,"title":title,"tradingType":1,"transactionNature":null,"transactionTypeFormId":"5ed488ce-ed95-6d93-96d0-3cc463951983","transactionTypeId":10003,"isSystem":1,"isDefault":false}
                    ]
                }

                let postObj = {"transactionsType":typeArr};
                
                this.postData('TransactionTypeList', postObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
                            self.fn_post();
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
            },

			fn_post: function(){
				let self = this;
				let postObj = JSON.parse(JSON.stringify(this.TransactionSettings))
				//for gstType/taxmode update
				postObj.transactionTypeId = [10001, 10002, 10003, 10004, 10005];
				postObj.taxMode = this.TransactionSettings.gstType;
				//for branch/division status update
				postObj.accountGroupId = accountGroupIds.brandAndDivision.id;
				postObj.status = this.TransactionSettings.branchDivision ? 1 : 2;

				postObj.additionalData = JSON.stringify(this.TransactionSettings);
				delete postObj.batchFields;
				this.postData('TransactionSettings', postObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.$root.fn_getTransactionSettings(()=>{
								self.showToast(self.$route.query.item ? 'Item settings updated' : 'Transaction settings updated');
							});
				          	// setTimeout(function(){
				          	// 	self.showToast('Transaction Settings updated');
							// 	self.$router.go(-1);
							// },300);
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_toggleParties: function(val){
				if(val){
					this.fn_addParties();
				}
				else{
					this.fn_removeParties();
				}
			},

			fn_addParties: function(val){
                let self = this;
                let partyGroups = [
					// entering creditor in sale forms
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"757c506e-9a73-e012-2632-4c29b0c0ac18","transactionTypePartyId":"910ede56-41c4-40cd-a0b7-82274dc0c071","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"33e66294-8148-1b9e-0090-50aa87b20cb5","transactionTypePartyId":"4bf238a8-086c-4716-9703-cae8bde11827","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"5ed488ce-ed95-6d93-96d0-3cc463951983","transactionTypePartyId":"8d80f210-73cb-45c2-913a-ca816f3ac284","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"e295c554-1dd5-e4f8-e8b7-4dacb7a096d6","transactionTypePartyId":"9626cb3f-b30f-4864-9a16-77dbf8c2c85c","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"e7e62fe1-3e70-49d1-a887-bf68953f48d8","transactionTypePartyId":"cbba4fbf-b6a2-454c-b0c8-679d4b2d96a0","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"e1dbb78d-995c-5f21-f845-03ca42de805b","transactionTypePartyId":"efab1ab3-96da-4d92-98cc-f996a44c92de","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"425524a0-8d67-7804-fbc9-3e7cca2a82bf","transactionTypePartyId":"8c0bca10-f1cf-4b40-aa69-9f794aa2dd19","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"400eddc0-9277-7d0d-5806-68c4507b8ac3","transactionTypePartyId":"5e9fa9d3-46f7-4b98-b55c-a92a6cdfbede","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"1e61de0c-bdd7-4e51-7758-4fccfdcea829","transactionTypePartyId":"bf21fe75-1eed-46c1-8f13-488bb6e71f87","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"208c0d5c-da96-4593-e126-f2e00a9f58fb","transactionTypePartyId":"c22bdfac-3c79-4274-8e30-13f5bcd5c2ad","isSystem":1},
					{"accountGroupId":"e755d16a-21f0-4c99-82e7-6be3bd2765e5","orderNumber":null,"transactionTypeFormId":"bb87606a-d063-4275-afb9-1cbadd1c78d0","transactionTypePartyId":"692da9c5-5cbe-4ca1-abde-8b593b55e305","isSystem":1},
					// entering debtor in purchase forms
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"9fb8a5ce-349a-787d-3111-243bcb648811","transactionTypePartyId":"73cbec33-ba72-4af0-a605-d4a8050267e8","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"97c5c10f-8fe0-e426-d970-38046569e5c8","transactionTypePartyId":"a68d88b7-ff35-4edb-895a-f5822ea67ee4","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"a2ca4fe2-a8cf-4ed0-926c-1b0801790914","transactionTypePartyId":"d0a0399c-b290-44f0-a405-5ffe46e4a74c","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"b8397f7f-d416-0e62-6cd2-09b6a1f88ea4","transactionTypePartyId":"b83b916c-cf5d-4fe9-ab06-6f96d8797ee9","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"d703ed08-b9c0-bc86-96da-3764d53b9779","transactionTypePartyId":"3c38f294-a282-4a7e-ae31-704267860612","isSystem":1},
					{"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","orderNumber":null,"transactionTypeFormId":"6b332fcd-59f7-28db-845c-06d7a8613f78","transactionTypePartyId":"58989bb2-8f67-42a9-921d-884f1ccd98c4","isSystem":1}
				];
				

                let postObj = {"transactionsTypeParties":partyGroups};
                
                this.postData('TransactionTypeParty', postObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
                            self.fn_post();
				        },
				        onError: function(error){
				          console.log(error);
						  self.showToast("Something went wrong");
						  self.TransactionSettings.showAllParties = !self.TransactionSettings.showAllParties;
				        }
					}
		        );
            },

			fn_removeParties: function(){
				let postObj = {	
					transactionsTypePartyIds:[
						"910ede56-41c4-40cd-a0b7-82274dc0c071",
						"4bf238a8-086c-4716-9703-cae8bde11827",
						"8d80f210-73cb-45c2-913a-ca816f3ac284",
						"9626cb3f-b30f-4864-9a16-77dbf8c2c85c",
						"cbba4fbf-b6a2-454c-b0c8-679d4b2d96a0",
						"efab1ab3-96da-4d92-98cc-f996a44c92de",
						"8c0bca10-f1cf-4b40-aa69-9f794aa2dd19",
						"5e9fa9d3-46f7-4b98-b55c-a92a6cdfbede",
						"bf21fe75-1eed-46c1-8f13-488bb6e71f87",
						"c22bdfac-3c79-4274-8e30-13f5bcd5c2ad",
						"692da9c5-5cbe-4ca1-abde-8b593b55e305",
						"73cbec33-ba72-4af0-a605-d4a8050267e8",
						"a68d88b7-ff35-4edb-895a-f5822ea67ee4",
						"d0a0399c-b290-44f0-a405-5ffe46e4a74c",
						"b83b916c-cf5d-4fe9-ab06-6f96d8797ee9",
						"3c38f294-a282-4a7e-ae31-704267860612",
						"58989bb2-8f67-42a9-921d-884f1ccd98c4"
					]
				}
				let self = this;
				this.postFilterData('deleteTransactionTypeParty', null, postObj, 
					{
						onSuccess: function(response){
							console.log(response);
							self.fn_post();
						}, 
						onError: function(error){
							console.log(error);
							self.showToast("Something went wrong");
							self.TransactionSettings.showAllParties = !self.TransactionSettings.showAllParties;
						}
					}
				);
			},

			fn_changePageSize: function(pageSize){
				this.TransactionSettings.printPageSize = pageSize;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_transactionDate: function(value){
				this.TransactionSettings.transactionDateStatus = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_toggleLogoStatement: function(value){
				this.TransactionSettings.removeLogoFromStatement = value;
				this.fn_post();
			},

			fn_toggleNotesInStatement: function(value){
				this.TransactionSettings.ledgerStatementNotes = value;
				this.fn_post();
			},

			fn_changeEstimateTitle: function(value){
				this.TransactionSettings.estimatePrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_changeLedgerCreditDebitLabels: function(value){
				this.TransactionSettings.ledgerCreditDebitLabelType = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_changeSaleReturnTitle: function(value){
				this.TransactionSettings.saleReturnPrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_changePurchaseReturnTitle: function(value){
				this.TransactionSettings.purchaseReturnPrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_toggleAutoRoundOff: function(value){
				this.TransactionSettings.isAutoRoundOff = value;
				this.fn_post();
			},

			fn_toggleCashSaleDefault: function(value){
				this.TransactionSettings.cashSaleDefault = value;
				this.fn_post();
			},

			fn_togglePartyBalance: function(value){
				this.TransactionSettings.showPartyBalance = value;
				this.fn_post();
			},

			fn_togglePrescribeDetails: function(value){
				this.TransactionSettings.enablePrescribeDetails = value;
				if(value){
					this.fn_postList();
				}
				this.fn_post();
			},

			fn_toggleReferredDetails: function(value){
				this.TransactionSettings.enableReferrerDetails = value;
				if(value){
					this.fn_postReferredList();
				}
				this.fn_post();
			},

			fn_toggleBarcodeScan: function(value){
				this.TransactionSettings.enableBarcodeScan = value;
				this.fn_post();
			},

			fn_togglePartyMobile: function(value){
				this.TransactionSettings.showPartyMobile = value;
				this.fn_post();
			},

			fn_toggleInvoiceOrientation: function(value){
				this.TransactionSettings.invoiceOrientation = value;
				this.fn_post();
			},

			fn_toggleSecondaryUnit: function(value){
				this.TransactionSettings.showSecondaryUnit = value;
				this.fn_post();
			},

			fn_toggleSalesman: function(value){
				this.TransactionSettings.enableSalesman = value;
				this.fn_post();
			},

			fn_toggleBroker: function(value){
				this.TransactionSettings.enableBroker = value;
				this.fn_post();
			},

			fn_toggleCustomerSignature: function(value){
				this.TransactionSettings.enableCustomerSignature = value;
				this.fn_post();
			},

			fn_toggleSingleLineAddOns: function(value){
				this.TransactionSettings.enableSingleLineAddOns = value;
				this.fn_post();
			},

			fn_toggleMfgExpDay: function(value){
				this.TransactionSettings.hideMfgExpDay = value;
				this.fn_post();
			},

			fn_toggleBankDetails: function(value){
				this.TransactionSettings.hideBankDetails = value;
				this.fn_post();
			},

			fn_toggleMRP: function(value){
				this.TransactionSettings.mrpWiseStock = value;
				if(!value){
					this.TransactionSettings.mrpAsSalePrice = false;
				}
				this.fn_post();
			},

			fn_toggleGodown: function(value){
				this.TransactionSettings.enableGodown = value;
				this.fn_post();
				// this.fn_addMainGodown();
			},

			// fn_addMainGodown: function(){
			// 	let dataObj = {"godownId":"4bbd673f-d325-46c5-9f0e-e5baf73c8152", "name":"Main Godown", "address":null, "stateId":this.$root.CurrentBusiness.StateID, "state":this.$root.CurrentBusiness.State, "additionalData":{}, "godownType":1};
			// 	this.postData('PostGodown', dataObj, 
			// 	{
			// 		onSuccess: function(response){
			// 			console.log(response);
			// 		},
			// 		onError: function(error){
			// 			console.log(error);
			// 		}
			// 	});
			// },

			fn_toggleEinvoice: function(value){
				this.TransactionSettings.enableEinvoice = value;
				this.fn_post();
			},

			fn_toggleEwayBill: function(value){
				this.TransactionSettings.enableEwayBill = value;
				this.fn_post();
			},

			fn_toggleBillofMaterials: function(value){
				this.TransactionSettings.enableBillMaterials = value;
				this.fn_post();
			},

			fn_toggleLowStockAlert: function(value){
				this.TransactionSettings.lowStockAlert = value;
				this.fn_post();
			},

			fn_toggleDuplicateCode: function(value){
				this.TransactionSettings.allowDuplicateCode = value;
				this.fn_post();
			},

			fn_toggleFullPagePrint: function(value){
				this.TransactionSettings.fullPagePrint = value;
				this.fn_post();
			},

			fn_togglePartyWiseRate: function(value){
				this.TransactionSettings.partyWiseRate = value;
				this.fn_post();
			},

			fn_toggleDueDate: function(value){
				this.TransactionSettings.dueDate = value;
				this.fn_post();
			},

			// fn_toggleReceivedAmount: function(value){
			// 	this.TransactionSettings.disableReceiveAmountLabel = value;
			// 	this.fn_post();
			// },

			fn_changeInvoiceTitle: function(value){
				this.TransactionSettings.invoicePrintTitle = value;
				this.$forceUpdate();
				this.fn_post();
			},
			
			fn_changeInvoiceDateFormat: function(dateFormat){
				this.TransactionSettings.invoiceDateFormat = dateFormat;
				this.$forceUpdate();
				this.fn_post();
			},

			fn_toggleBatch: function(){
				this.dialogBatchFields = true;
			},

			fn_enableBatchAndFields: function(value){

				let fields = [];
				for(let key in this.batchFields){
					delete this.batchFields[key].selected;
					if(this.batchFields[key].status){
						fields.push(this.batchFields[key]);
					}
				}
				
				if(fields.length == 1 && fields[0].id == 'opening'){
					this.showToast('All fields are disabled');
					return;
				}
				

				// this.TransactionSettings.batchFields = [];
				this.TransactionSettings.batchFields = JSON.parse(JSON.stringify(fields));

				// for(let key in this.batchFields){
				// 	delete this.batchFields[key].selected;
				// 	if(this.batchFields[key].status){
				// 		this.TransactionSettings.batchFields.push(this.batchFields[key]);
				// 	}
				// }
				// this.batchFields.forEach(item=>{
				// 	delete item.selected;
				// 	if(item.status){
				// 		this.TransactionSettings.batchFields.push(item);
				// 	}
				// })

				// for(let i=0; i<this.batchFields.length; i++){
				// 	delete this.batchFields[i].selected;
				// 	if(this.batchFields[i].status){
				// 		this.TransactionSettings.batchFields.push(JSON.parse(JSON.stringify(this.batchFields[i])));
				// 	}
				// }
				

				if(value === true){
					this.dialogBatchFields = true;
				}
				else{
					this.dialogBatchFields = false;
				}

				this.reorder = false;
				// this.dialogBatchFields = false;
				this.fn_post();
			},

			fn_selectToReorder: function(obj){
				if(this.reorder){
					// for(let key in this.batchFields){
					// 	this.batchFields[key].selected = false;
					// }
					this.batchFields.forEach(item => {
						item.selected = false;
					});
					obj.selected = true;
					this.$forceUpdate();
				}
			},

			fn_moveField: function(type){
				let itemIndex = this.batchFields.findIndex(item=>{return item.selected});
				let tempItem = this.batchFields[itemIndex];
				this.batchFields.splice(itemIndex, 1);
				let insertIndex = type == 'up' ? itemIndex - 1 : itemIndex + 1;
				this.batchFields.splice(insertIndex, 0, tempItem);
				for(let i=0; i<this.batchFields.length; i++){
					this.batchFields[i].orderNumber = i + 1;
				}
			},

			fn_isMoveDownDisabled: function(){
				let itemIndex = this.batchFields.findIndex(item=>{return item.selected});
				if(itemIndex == this.batchFields.length - 1 || itemIndex == -1){
					return true;
				}
				else{
					return false;
				}
			},

			fn_isMoveUpDisabled: function(){
				let itemIndex = this.batchFields.findIndex(item=>{return item.selected});
				if(itemIndex == 0 || itemIndex == -1){
					return true;
				}
				else{
					return false;
				}
			},

			fn_openDialogAddFields: function(){
				this.dialogBatchFields = true;
				this.reorder = false;
			},

			fn_postList: function(){
				var self = this;
				let dataObj = {"listsId":"prescribe_by_details","name":"Doctors","title":"Doctors","description":"Details of prescriber","groupTypeId":401,"isSystem":1}
				this.postData('Lists', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_postReferredList: function(){
				let dataObj = {"listsId":"referred_by_details","name":"References","title":"References","description":"Details of reference","groupTypeId":401,"isSystem":1}
				this.postData('Lists', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			// fn_togglePacking: function(val){
			// 	if(val && !this.TransactionSettings.packingLabel){
			// 		this.fn_openDialogTextBox();
			// 	}
			// 	this.fn_post();
			// },

			fn_openDialogTextBox: function(){
				if(this.TransactionSettings.packingLabel){
					this.dialogTextContent = this.TransactionSettings.packingLabel;
				}
				else{
					this.dialogTextContent = "Pack Qty";
				}
				this.$forceUpdate();
				setTimeout(() => {
					this.fn_openDialogWeb('web', 'TextBox', 'ref_dialogText');
				}, 300);
			},

			fn_saveText: function(content){
				this.TransactionSettings.packingLabel = content;
				this.$forceUpdate();
				this.fn_post();
				this.fn_closeDialog();
			},

			fn_accountGroupSetting: function(){
				this.$router.push({path:'/settings/accountgroup', query:{tagId:this.guidWeb()}});
				// this.fn_openDialogWeb('web', 'AccountGroupSettings', 'ref_dialogAccountGroupSettings');
			}
	  	},

	  	mounted: function(){
	  		this.formId = this.guidWeb();
			this.dialogStorageId = 'dialog_'+this.formId;
			this.TransactionSettings = JSON.parse(JSON.stringify(this.$root.TransactionSettings));
			if(this.TransactionSettings.defaultPaymentMode == 1){
				this.selectedPaymentMode = {"title":"Last Remember", "value":1};
			}
			else if(this.TransactionSettings.defaultPaymentMode == 2){
				this.selectedPaymentMode = {"title":"Cash", "value":2};
			}
			else if(this.TransactionSettings.defaultPaymentMode == 3){
				this.selectedPaymentMode = {"title":"Credit", "value":3};
			}
			this.fn_checkTaxMode();

			this.currenDateTimer = setInterval(()=>{
				this.currentDate = new Date();
			}, 1000 * 60 * 1);

			if(this.TransactionSettings.batchFields && this.TransactionSettings.batchFields.length){
				let fields = this.TransactionSettings.batchFields.filter(item=>{return !item.isDefault});
				if(fields && fields.length){
					for(let j=0; j<this.batchFields.length; j++){
						!this.batchFields[j].isDefault ? this.batchFields[j].status = false : '';
						for(let i=0; i<fields.length; i++){
							if(this.batchFields[j].title == fields[i].title){
								this.batchFields[j].status = true;
								break;
							} 
						}
					}
				}
			}
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  	},
	  	beforeRouteLeave (to, from, next) {
	    	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
				next(false);
			}
			else if(this.dialogBatchFields){
				this.dialogBatchFields = false;
				next(false);
			}
			else if(this.askToQuit){
				this.fn_openDialogConfirmation();
				next(false);
			}
			else{
				clearInterval(this.currenDateTimer);
				next();
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/transaction_settings/transaction_settings_new.vue